// components/Layout.tsx
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../redux/hooks';
import { logoutUser } from '../../redux/auth/authSlice';

const InactivityTimeout = 15 * 60 * 1000; // 15 minutes in milliseconds

function TimeOutActivityLayout({ children }) {
  const [userInactive, setUserInactive] = useState(false);
  const dispatch = useAppDispatch();
  let inactivityTimer: NodeJS.Timeout;

  const resetInactivityTimer = () => {

   // console.log('timer reset');
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(() => {
      // User has been inactive for 15 minutes, perform logout action here
      logoutMeOut();
    }, InactivityTimeout);
  };

  const logoutMeOut = () => {
    // Perform logout logic, e.g., redirect to the login page or clear user session
    // You should customize this based on your authentication and app structure.
    dispatch( logoutUser());
  };

  useEffect(() => {
    resetInactivityTimer();

    // Event listeners to track user activity
    window.addEventListener('mousemove', resetInactivityTimer);
    window.addEventListener('keydown', resetInactivityTimer);

    return () => {
      // Clean up event listeners when the component unmounts
      window.removeEventListener('mousemove', resetInactivityTimer);
      window.removeEventListener('keydown', resetInactivityTimer);
    };
  }, []);

  return (
    <div>
      {userInactive ? (
        <div>
          <p>You have been logged out due to inactivity.</p>
          {/* You can provide a login link or a button to re-login the user */}
        </div>
      ) : (
        <div>
          {children}
        </div>
      )}
    </div>
  );
}

export default TimeOutActivityLayout;
